import type { UploadFileItem } from "@/components/upload";

export type FeedbackWidgetMode = "csat" | "default" | "nps";

export type FeedbackWidgetValue = "bug" | "feedback";

export type FeedbackWidgetCancelDetail = {
  feedbackType: Exclude<FeedbackWidgetMode, "default"> | FeedbackWidgetValue | null;
};

export type FeedbackWidgetSubmitDetail = {
  dontAskAgain?: boolean;
  feedback: string;
  feedbackType: string;
  rating?: number;
  screenshots?: UploadFileItem[];
  title?: string;
};

export interface CsatRating {
  emoji: string;
  label: string;
  value: number;
}

export interface FeedbackSubtype {
  label: string;
  placeholder: string;
  textLabel: string;
  value: string;
}

export interface Option {
  description: string;
  icon: string;
  label: string;
  value: FeedbackWidgetValue;
}

export const NPS_SCORES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const CSAT_RATINGS: CsatRating[] = [
  { emoji: "😩", label: "Terrible", value: 1 },
  { emoji: "🙁", label: "Bad", value: 2 },
  { emoji: "😐", label: "Neutral", value: 3 },
  { emoji: "🙂", label: "Good", value: 4 },
  { emoji: "😀", label: "Great", value: 5 },
];

export const FEEDBACK_SUBTYPES: FeedbackSubtype[] = [
  {
    label: "Suggestion",
    placeholder: "Write your suggestion...",
    textLabel: "Your suggestion",
    value: "suggestion",
  },
  {
    label: "Compliment",
    placeholder: "Write your compliment...",
    textLabel: "Your compliment",
    value: "compliment",
  },
  {
    label: "General",
    placeholder: "Write your feedback...",
    textLabel: "Your feedback",
    value: "general",
  },
];

export const OPTIONS: Option[] = [
  {
    description: "Something's not working right",
    icon: "alert-triangle",
    label: "Report a bug",
    value: "bug",
  },
  {
    description: "Suggestions and comments",
    icon: "message-text-square-01",
    label: "Provide feedback",
    value: "feedback",
  },
];
